import WondeBaseSerializer from './base';

export default class Connection extends WondeBaseSerializer {}
